import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ValidatorForm } from "react-form-validator-core";
import TextValidator from "../partial/TextValidator";
import SelectValidator from "../partial/SelectValidator";
import { getDate, selectValueGetter } from "../../utils/helper";
import { Tab, Tabs } from "react-bootstrap";
import { backIcon2 } from "../../Image/Index";
import { UpdateMerchantLimitData, getMerchantWallet, redeemDeductWallet, } from "../../actions/auth";
import swal from "sweetalert";
import Page from "./Page";
import AdminHeader from "../layout/AdminHeader";

const WalletReport = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const [selectedData ,setSelectedData] = useState("credit")
    const [totalData,setTotalData] = useState([])
    const [accounttypes, setAccountTypes] = useState()
    const [totalLimit ,setTotalLimit] = useState()
    const [totalBalance ,setTotalBalance] = useState()
    const [totalSpend ,setTotalSpend] = useState()
    const [loader, setLoader] = useState(false);
    const [show, setShow] = useState(false);
    const [state, setState] = useState({
        wallet: " ",
        pointWalletSummary: "",
        totalLength: 0,
        amount: "",
        description:"",
        transactionId: "",
        selectedTypeId: { label: "Point", value: "Point" },
        options: [
            { label: "Point", value: "Point" },
            // { label: "Voucher", value: "voucher" },
        ],
        
    });
    let merchantCode
   

    const [optionsData] = useState([
        { label: "Credit", value: "credit" },
        { label: "Debit", value: "debit" },
    ]);

    if( localStorage.getItem("merchantId")) {
        merchantCode = localStorage.getItem("merchantId")
    }
    else {
        const merchantId = location?.state?.merchcode
        const names = location?.state?.name
        localStorage.setItem("names",names)
        localStorage.setItem("merchantId",merchantId)
        merchantCode = localStorage.getItem("merchantId")
    }

    const { wallet, pointWalletSummary, totalLength, amount, transactionId, selectedTypeId, options, description } = state;
    const [currentPage, setCurrentPage] = useState(0);
    const pageSize = 10;
    const pageCount = Math.ceil(totalData?.length / pageSize);
    const fetchWallet = async () => {
        let temp = [];
        setLoader(true);
        const token = JSON.parse(localStorage.getItem("token_gen1"));
       getMerchantWallet(token?.access_token, merchantCode)
        .then((res) => {
            setState((prev) => ({
                ...prev,
                wallet: res?.data,
            }));
            // res?.data?.transactions?.map((val) => {
            //     return temp.push({ 
            //         date: val?.transactionDetail?.transactionDate, 
            //         value: val?.transactionDetail?.values,
            //         status: "debit"
            //     })
            // });
            // res?.data?.queryforHistoryData?.map((val) => {
            //     return temp.push({ 
            //         date: val?.createdAt, 
            //         value: val?.value,
            //         status: "credit"
            //     })
            // });
            setLoader(false);
            setTotalData(res?.data?.queryforHistoryData)
            
        });
    };

    useEffect(() => {
        fetchWallet();
    }, []);

    useEffect(() => {

        state?.wallet?.wallets?.map((item) => {
            if (item?.accounttype === "Point") {
                setAccountTypes(item?.accountName)
                setTotalLimit(item?.limit)
                setTotalBalance(item?.balance)
                setTotalSpend(item?.used)
            }
        });

        // const combinedData = [];
        // state?.wallet?.transactions?.forEach((transaction) => {
        //   const { transactionDetail } = transaction;
        //   combinedData.push({
        //     value: transactionDetail.values,
        //     date: transactionDetail.transactionDate,
        //     status: "debit"
        //   });
        // });
        // state?.wallet?.queryforHistoryData?.forEach((history) => {
        //   combinedData.push({
        //     value: history.value,
        //     date: history.createdAt,
        //     status: "credit"
        //   });
        // });
      
        // return combinedData;
        
    }, [state]);

   
    const handleChange = (e) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, "");
        setState({ ...state, [e.target.name]: e.target.value });
    };

    const handleChangeData = (e) => {
        setState({ ...state, description: e.target.value });
    };


    const onSelectChange = (e) => setState({ ...state, selectedTypeId: { ...e } });
    const onSelectData = (e) =>{
        setSelectedData(e.value)
    }

    const handleViewModal = (id) => {
        setShow(true);
        setState((prev) => ({
            ...prev,
            transactionId: id,
        }));
    };
 
    const onSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        if(selectedData === "debit"){
            const token = JSON.parse(localStorage.getItem("token_gen1"));
            redeemDeductWallet(token?.access_token, merchantCode, amount,description ? description :"NA")
                .then((Setting) => {
                    if(Setting.message.toLowerCase() === "success"){
                        swal({
                            position: "center",
                            icon: "success",
                            title: "Point debited from account successfully",
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    }
                    else{
                        swal({
                            position: "center",
                            icon: "error",
                            title: "Process incomplete",
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    }
                   
                    setLoader(false);
                    setSelectedData("credit")
                    fetchWallet()
                    setState({
                        wallet: " ",
                        pointWalletSummary: "",
                        totalLength: 0,
                        amount: "",
                        description:"",
                        transactionId: "",
                        selectedTypeId: { label: "Point", value: "Point" },
                        options: [
                            { label: "Point", value: "Point" },
    
                        ],
                    });
                })
                .catch((err) => {
                    swal({
                        position: "center",
                        icon: "error",
                        title: err.message,
                        showConfirmButton: false,
                        timer: 10000,
                    });
                    setLoader(false);
                });
            
        }
        else{

        
        const token = JSON.parse(localStorage.getItem("token_gen1"));
        UpdateMerchantLimitData(token?.access_token, merchantCode, amount, description ? description :"NA")
            .then((Setting) => {
                swal({
                    position: "center",
                    icon: "success",
                    title: "Point added in your account successfully",
                    showConfirmButton: false,
                    timer: 5000,
                });
                setLoader(false);
                fetchWallet()
                setState({
                    wallet: " ",
                    pointWalletSummary: "",
                    totalLength: 0,
                    amount: "",
                    description:"",
                    transactionId: "",
                    selectedTypeId: { label: "Point", value: "Point" },
                    options: [
                        { label: "Point", value: "Point" },

                    ],
                });
            })
            .catch((err) => {
                swal({
                    position: "center",
                    icon: "error",
                    title: err.message,
                    showConfirmButton: false,
                    timer: 10000,
                });
                setLoader(false);
            });
        }
    };

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <AdminHeader name={"Wallet Report"} />
            <div className="dashboard__content">
                {/* {show && <TransactionViewModal show={show} close={() => setShow(false)} transactionId={show && transactionId} />} */}
                <div className="container-fluid">
                    <div className="dashboard__customerViewMain">
                        <div className="dashboard__heading">
                            <div className="dashboard__headingLeft">
                                <div className="dashboard__headingBackLink">
                                    <Link to="" onClick={() => navigate(-1)}>
                                        <img src={backIcon2} alt="" />
                                    </Link>
                                </div>
                                <div className="dashboard__headingContent">
                                    <h3>Back</h3>
                                </div>
                            </div>
                            {/* <Link to = "/gift-card" className="dashboard__headingLeft">
                             
                            <button className="btn btn-primary">
                                  Gift Card
                                </button>
                            </Link> */}
                        </div>
                        <div className="dashboard__customerViewCard">
                            <div className="dashboard__customerViewProfile">
                                <div className="dashboard__customerViewDetails w-100">
                                    <div className="dashboard__customerViewTop">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="dashboard__customerViewHeading">
                                                    <ValidatorForm className="signUpPage__formSection" onSubmit={onSubmit}>
                                                        <div className="row mb30">
                                                            <div className="col-md-4">
                                                                <SelectValidator className="" name="choice" value={selectValueGetter(options, selectedTypeId.value)} options={options} onChange={onSelectChange} validators={["required"]} errorMessages={["Please enter your industry"]} />
                                                            </div>
                                                            <div className="col-md-4 reportUI">
                                                                <TextValidator className="form-control" placeholder="No. of points" name="amount" value={amount} maxLength="6" validators={["required", "matchRegexp:^[1-9][0-9]*$"]} errorMessages={["Amount is required.", "Please enter a valid amount (greater than zero)"]} onChange={handleChange} />
                                                            </div>
                                                          
                                                          
                                                            
                                                         
                                                            <div className="col-md-4">
                                                                <SelectValidator className="" name="choice" value={selectValueGetter(optionsData, selectedData)} options={optionsData} onChange={onSelectData} validators={["required"]} errorMessages={["Please enter your industry"]} />
                                                            </div>
                                                            
                                                            </div>
                                                            <div className="row mb30" >
                                                     
                                                            <div className="col-md-12 reportUI">
                                                                <textarea className="form-control" placeholder="Description" name="description" value={description}  onChange={handleChangeData} />
                                                            </div>
                                                          
                                                           
                                                            </div>
                                                    
                                                    <div className="row">
                                                    <div className="col-md-3 offset-md-9">
                                                                <button type="submit" className="btn btn-primary btn-lg w-100">
                                                                    Update
                                                                </button>
                                                            </div>
                                                    </div>
                                                    </ValidatorForm>
                                                </div>
                                            </div>
                                        </div>
                                        {/* {amount && (
                                            <h2>
                                                Total points you earn : <b>{amount * 4}</b>
                                            </h2>
                                        )} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard__customerViewCard">
                            <div className="dashboard__customerViewPointsTabs">
                                <Tabs id="customerViewPointsTabs">
                                    <Tab eventKey="Wallet" title="Wallet">
                                        <div className="dashboard__customerViewPoints">
                                            <div className="row">
                                            <div className="col-lg-4">
                                                    <div className="dashboard__customerViewBox m-0">
                                                        <h4>Balance</h4>
                                                        <h2>{totalBalance ? totalBalance :0}</h2>
                                                    </div>
                                                </div>
                                               
                                                <div className="col-lg-4">
                                                    <div className="dashboard__customerViewBox m-0">
                                                        <h4>Spent</h4>
                                                        <h2>{totalSpend ? totalSpend : 0}</h2>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="dashboard__customerViewBox m-0">
                                                        <h4>Credit</h4>
                                                        <h2>{totalLimit ? totalLimit :0}</h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="Finance Summary" title="Finance Summary">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-bordered finance_summary_table">
                                                <thead>
                                                    <tr>
                                               
                                                        <th>Point</th>
                                                        <th>Amount (&#8377;)</th>
                                                        <th>Date</th>
                                                        <th>Merchant ID</th>
                                                        <th>Type</th>
                                                        <th>Status</th>
                                                        <th>Description</th>
                                                    </tr>
                                                </thead>
                                                {
                                                    <tbody>
                                                 
                                                        {totalData && totalData.length > 0
                                                            ? totalData .sort((a, b) => {
                                                                const aDiff = Math.abs(new Date(a.createdAt) - new Date());
                                                                const bDiff = Math.abs(new Date(b.createdAt) - new Date());
                                                                return aDiff - bDiff;
                                                            })
                                                            .slice(currentPage * pageSize, (currentPage + 1) * pageSize).map((statement, i) => (
                                                                <tr key={i}>
                                                               
                                                                    <td>{statement?.value}</td>
                                                                    <td>{(statement?.value / 4)}</td>
                                                                    <td>{getDate(statement?.createdAt, "DD-MM-YYYY")}</td>

                                                                    <td>
                                                                       {merchantCode}
                                                                    </td>
                                                                    <td>
                                                                        {statement?.operationType === "Deduct" ? "Debit" : statement?.operationType === "Redeem" ? "Debit" : statement?.operationType === "Refund" ? "Credit" :statement?.operationType }
                                                                    </td>
                                                                    <td>
                                                                        {statement?.operationType === "Deduct" ? "Debit" : statement?.operationType === "Debit" ? "Redeem" : statement?.operationType}
                                                                    </td>
                                                                    <td><div className="">{statement?.description}</div></td>
                                                                </tr>
                                                            ))
                                                            :   <tr>
                                                            <td colSpan="4">
                                                                <h6 className="text-center">No Record Found</h6>
                                                            </td>
                                                        </tr>}
                                                    </tbody>
                                                }
                                              
                                            </table>
                                        </div>
                                        
                                        {totalData && totalData?.length > 10 && (
                                            <div>
                                                <div className="dashboard__paginationBox">
                                                    <Page currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pageCount} value={5} />
                                                </div>
                                            </div>
                                        )}
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WalletReport;
